import styled from "styled-components";
export const Card = styled.div`
  border-radius: 4px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.48);
  display: block;
  padding: 24px;
  position: relative;
`;
export const CardBorder = styled(Card)`
  border: 1px solid ${props => props.theme.colors.disabledText};
  box-shadow: none;
`;